import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BibleState } from './types';

const initialState: BibleState = {
  selectedVersion: null
};

const bibleSlice = createSlice({
  name: 'bible',
  initialState,
  reducers: {
    setSelectedVersion: (state, action: PayloadAction<number>) => {
      state.selectedVersion = action.payload;
    }
  }
});

export const bibleActions = bibleSlice.actions;

export default bibleSlice.reducer;
